import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../../util/utilityfunctions';

function PrintViewKnowledgeDescription(props) {
	const {body, bodyDescription} = props;

	const mainBodyKey = `form-${body.id}-knowledge`;

	return (
		<StyledPrintViewKnowledgeDescription className="StyledPrintViewKnowledgeDescription" key={mainBodyKey}>
			{Utility.createRichTextElement(bodyDescription)}
		</StyledPrintViewKnowledgeDescription>
	);
}

export default PrintViewKnowledgeDescription;

const StyledPrintViewKnowledgeDescription = styled.section`
	font-size: inherit;
	width: 100%;
	line-height: normal;
	ins {
		font-size: inherit;
		line-height: normal;
		del {
			font-size: inherit;
		}
	}
	div {
		font-size: inherit;
		del {
			font-size: inherit;
		}
		strong {
			font-size: inherit;
		}
		em {
			font-size: inherit;
		}
	}
	p {
		font-size: inherit;
		line-height: normal;
		margin-bottom: 0 !important;
		line-height: var(--px-16);
		span {
			font-size: inherit;
			line-height: normal;
		}
		del {
			font-size: inherit;
		}
		strong {
			font-size: inherit;
		}
		em {
			font-size: inherit;
		}
	}
	span {
		width: 100%;
		color: var(--neutrals-900);
		font-size: inherit;
		line-height: normal;
		del {
			font-size: inherit;
		}
		div {
			font-size: inherit;
			line-height: normal;
		}
		blockquote {
			font-size: inherit;
			line-height: normal;
		}
		ul {
			display: block;
			list-style-type: disc;
			margin-block-end: var(--px-10);
			margin-block-start: 0;
			margin-bottom: var(--px-10);
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin-top: var(--px-10);
			padding-inline-start: var(--px-24);
			padding-left: var(--px-24);
			li {
				font-size: inherit;
				margin-bottom: calc(var(--px-1) * -1);
				font-weight: 500;
				list-style-type: disc;
			}
		}
		ol {
			margin-block-end: var(--px-10);
			margin-block-start: 0;
			margin-bottom: var(--px-10);
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin-top: 0;
			padding-inline-start: var(--px-24);
			padding-left: var(--px-24);
			li {
				font-size: inherit;
				margin-bottom: calc(var(--px-1) * -1);
				font-weight: 500;
			}
		}
		h6 {
			font-weight: bold;
			line-height: var(--px-32);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				line-height: var(--px-40);
			}
		}
		h5 {
			font-weight: bold;
			line-height: var(--px-32);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				line-height: var(--px-40);
			}
		}
		h4 {
			font-weight: bold;
			font-size: inherit;
			line-height: var(--px-32);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				font-size: inherit;
				line-height: var(--px-40);
			}
		}
		h3 {
			font-weight: bold;
			line-height: var(--px-32);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				line-height: var(--px-40);
			}
		}
		h2 {
			font-weight: bold;
			line-height: var(--px-40);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				line-height: var(--px-50);
			}
		}
		h1 {
			font-weight: bold;
			line-height: var(--px-48);
			margin-block-end: 0;
			margin-block-start: 0;
			margin-inline-end: 0;
			margin-inline-start: 0;
			margin: 0;
			padding: 0;
			em {
				line-height: var(--px-60);
			}
		}
	}
	td {
		font-weight: 500;
		font-size: inherit;
		padding: var(--px-2) var(--px-3);
	}
	tr,
	th,
	td {
		font-weight: 500;
		font-size: inherit;
		padding: var(--px-2) var(--px-3);
		border: var(--px-1) solid var(--neutrals-300);
		border-collapse: collapse;
		background-color: transparent;
		span {
			font-size: inherit;
		}
	}
	table {
		width: calc(100% - var(--px-100)) !important;
		border-collapse: collapse;
		background-color: transparent;
	}
`;
